G.WorldMapLvlButton = function(editorMode) {
	// imports
	var treasureHuntMgr = G.TreasureHunt.treasureHuntMgr;

	G.Button.call(this,0,0,null,this.handleClick,this);

	this.buttonScale = G.OMTsettings.elements.worldMapLvlButton.scale || 1;

  this.editorMode = editorMode;

	this.state = game.state.getCurrentState();

	this.starsImg = G.makeImage(0,30,null,0.5,this);
  this.lvlNrTxt = this.addChild(new G.Text(0, -16, "1", G.OMTsettings.elements.worldMapLvlButton.lvlNrText.style , 0.5));

	this.state = game.state.getCurrentState();

	this.addTerm(function() {
		return this.state.EDITOR || !G.Helpers.gatesMgr.isLevelBehindGate(this.lvlIndex);
	},this);

	this.kill();

	if (this.editorMode) {
		G.sb("editorLevelSelected").add(this.editorCheckTint, this);
	}
	G.Utils.cleanUpOnDestroy(this,
		treasureHuntMgr.onEventTurnedOnChange.add(this.setTreasureHuntWrapper, this));
};


G.WorldMapLvlButton.prototype = Object.create(G.Button.prototype);


G.WorldMapLvlButton.prototype.handleClick = function() {
	if (!this.editorMode && !this.lvlAvailable) return;

	if (this.editorMode) {
		this.state.selectLevel(this.lvlId);
		this.IMMEDIATE = true;
	} else {
		G.lvlNr = this.lvlIndex;
		G.lvlData = G.Helpers.levelDataMgr.getLevelByIndex(this.lvlIndex);
		if (G.saveState.getLives() == 0 && G.saveState.getUnlimitedLivesSec() == 0) {
			G.sb("pushWindow").dispatch(["notEnoughLives", {
        openLevelPopUp: true,
        lvlIndex: this.lvlIndex,
        levelPopUpLayerName: G.WindowMgr.LayerNames.AboveHighScorePanel
      }], false, G.WindowMgr.LayerNames.AboveHighScorePanel);
		} else {
			G.sb("pushWindow").dispatch(['level', this.lvlIndex], false, G.WindowMgr.LayerNames.Base);
		}
	}
};

G.WorldMapLvlButton.prototype.revealChange = function() {
	game.add.tween(this.starsImg.scale).to({x:1,y:1},500,Phaser.Easing.Elastic.Out,true,1500).onComplete.add(function(){
		this.inputEnabled = true;
		this.input.useHandCursor = true;
	},this);
	this.state.lastLevelData.lvlNr = -999;
}

G.WorldMapLvlButton.prototype.init = function(index,lvlData) {
  this.alpha = 1;
	this.stopPulse(this.buttonScale);
	this.revive();
	G.stopTweens(this);
	G.stopTweens(this.starsImg);
	this.starsImg.scale.setTo(1);

  this.lvlId = lvlData.id;
  this.x = G.l(lvlData.mapX);
  this.y = G.l(lvlData.mapY);
  this.lvlIndex = index;
  this.lvlAvailable = G.saveState.isLevelAvailable(this.lvlIndex);
  this.lvlStarsNr = G.saveState.getStars(this.lvlIndex);

  if (this.editorMode) {
    return this._initEditor(index, lvlData);
  }

	if (this.lvlAvailable) {

		this.lvlNrTxt.visible = true;
		this.lvlNrTxt.setText((this.lvlIndex+1).toString());

		if (this.lvlStarsNr == 0) {
			G.changeTexture(this,'map_point_2');
			G.changeTexture(this.starsImg,null);
			this.pulse(this.buttonScale + 0.1);
		}else {
			G.changeTexture(this, 'map_point');
			G.changeTexture(this.starsImg,'map_star_'+this.lvlStarsNr);
		}

		this.inputEnabled = true;
		this.input.useHandCursor = true;

	}else {
		G.changeTexture(this,'map_point');
		G.changeTexture(this.starsImg,null);
		this.lvlNrTxt.visible = false;
		this.alpha = 0.5;
		this.inputEnabled = false;
		this.input.useHandCursor = false;
	}

	if (lvlData.showAsHard) {
		G.changeTexture(this, 'map_point_hard');
	}

	this.setTreasureHuntWrapper();

};

G.WorldMapLvlButton.prototype._initEditor = function(index, lvlData) {
  this.changeTexture("map_point");
  this.lvlNrTxt.setText(index+1);

  if (this.tutInfo) this.tutInfo.destroy();
  if (lvlData.tutID) {
    this.tutInfo = this.add(new G.Text(0, -50, "TUT: "+lvlData.tutID, {
      style: "editor",
      fontSize: 20,
      fill: "#00ff00",
    }, 0.5));
  }

  if (this.goalsInfo) this.goalsInfo.destroy();
  this.goalsInfo = this.add(this.createGoalsEditorInfo(0, 20, lvlData));

  if (lvlData.showAsHard) {
    G.changeTexture(this, 'map_point_hard');
  }

  this.editorCheckTint();
};

G.WorldMapLvlButton.prototype.setTreasureHuntWrapper = function() {
	// imports
	var treasureHuntMgr = G.TreasureHunt.treasureHuntMgr;
  var active = treasureHuntMgr.isEventActive();

	if (!this.alive) return;

	if (active && treasureHuntMgr.isLevelTreasureHuntActive(this.lvlIndex)) {
		this._treasureHuntWrapper = G.makeImage(0, 0, "trasure_hunt_wrapper", 0.5, this);
    this.sendToBack(this._treasureHuntWrapper);
	} else {
		if (this._treasureHuntWrapper) {
      this._treasureHuntWrapper.destroy();
    }
	}
};

G.WorldMapLvlButton.prototype.editorCheckTint = function() {
	if (this.editorMode) {
		if (this.state.selectedLevels.includes(this.lvlId)) {
			this.tint = 0x00ff00;
		} else {
			this.tint = 0xffffff;
		}
	}
};

G.WorldMapLvlButton.prototype.createGoalsEditorInfo = function(x, y, lvlData) {
  var group = game.add.group();
  group.position.setTo(x, y);

  if (lvlData.goal[0] === "collect") {
    lvlData.goal[1].forEach(function(entry) {
      G.makeImage(0, 0, G.json["configs/gameplayGoals"][entry[0]].sprite, 0.5, group);
    });
    G.centerElements2(group.children, 5);
    group.scale.setTo(0.5);
  } else {
    group.add(new G.Text(0, 0, lvlData.goal[1], {
      style: "editor",
      fontSize: 20,
    }, 0.5))
  }

  return group;
};
